import React from 'react';
import { DTEConfigurationForm } from '../../types/hacienda/DTEConfigurationTypes';
import { DropdownDTO } from '../../types/common/DropdownDTO';
import SelectField from '../Forms/Input/SelectField';
import InputField from '../Forms/Input/InputField';

interface DTEConfigurationFormProps {
  form: DTEConfigurationForm;
  errors?: Record<string, string>;
  environments: DropdownDTO[];
  currencies: DropdownDTO[];
  billingModels: DropdownDTO[];
  transmissionTypes: DropdownDTO[];
  isLoading: boolean;
  isSubmitting: boolean;
  onChange: (e: React.ChangeEvent<any>) => void;

  /** ✅ ahora siempre será true */
  onSave: () => void;
}

const DTEConfigurationFormComponent: React.FC<DTEConfigurationFormProps> = ({
  form,
  errors = {},
  environments,
  currencies,
  billingModels,
  transmissionTypes,
  isLoading,
  isSubmitting,
  onChange,
  onSave,
}) => {
  return (
    <div className="space-y-10 p-4 px-4 py-5">
      {/* Descripción */}
      <div className="text-gray-600 dark:text-gray-300 mb-6 text-sm">
        <p className="mt-2">
          Esta configuración define los parámetros oficiales para la emisión de Documentos Tributarios Electrónicos (DTE).
        </p>
      </div>

      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-2">
        {/* Ambiente */}
        <SelectField
          label="Ambiente de Destino"
          name="environmentId"
          value={form.environmentId ?? ''}
          onChange={onChange}
          options={environments.map((opt) => ({
            value: opt.id,
            label: opt.name,
          }))}
          iconKey="list"
          error={errors.environmentId}
        />

        {/* Moneda */}
        <SelectField
          label="Moneda"
          name="currencyId"
          value={form.currencyId ?? ''}
          onChange={onChange}
          options={currencies.map((opt) => ({
            value: opt.id,
            label: opt.name,
          }))}
          iconKey="list"
          error={errors.currencyId}
        />

        {/* Modelo */}
        <SelectField
          label="Modelo de Facturación"
          name="billingModelId"
          value={form.billingModelId ?? ''}
          onChange={onChange}
          options={billingModels.map((opt) => ({
            value: opt.id,
            label: opt.name,
          }))}
          iconKey="list"
          error={errors.billingModelId}
        />

        {/* Transmisión */}
        <SelectField
          label="Tipo de Transmisión"
          name="transmissionTypeId"
          value={form.transmissionTypeId ?? ''}
          onChange={onChange}
          options={transmissionTypes.map((opt) => ({
            value: opt.id,
            label: opt.name,
          }))}
          iconKey="list"
          error={errors.transmissionTypeId}
        />

        {/* Versión de Invalidación */}
        <InputField
          label="Versión de Invalidación"
          name="versionInvalidation"
          type="number"
          value={form.versionInvalidation ?? ''}
          onChange={onChange}
          error={errors.versionInvalidation}
          min={1}
          iconKey="list"
          required
        />
      </div>

      {/* Botón Guardar */}
      <div className="mt-6">
        <button
          onClick={onSave}
          disabled={isSubmitting || isLoading}
          className="rounded bg-blue-600 px-4 py-2 text-white hover:bg-blue-700"
        >
          {isSubmitting ? 'Guardando...' : 'Guardar Configuración'}
        </button>
      </div>
    </div>
  );
};

export default DTEConfigurationFormComponent;
